import React from 'react'
import { Wrapper } from './style.css'

const Final = () => {
  return (
    <Wrapper className="grid grid-cols-12">
      <div className="flex items-center justify-center col-span-5 p-4 text-left sm:pl-32 col1 bg-verde">
        <h2 className="text-2xl font-bold leading-none sm:text-6xl text-amarillo">
          ¡Gracias!
          <small className="block">Tu voto ha sido guardado.</small>
        </h2>
      </div>
      <div className="flex items-center justify-center col-span-7 p-4 text-left bg-grispurpura">
        <a
          href="https://www.lacuarta.com/?utm_source=landing&amp;utm_medium=copihuedeoro.cl"
          className="text-xl font-bold underline sm:text-5xl focus:outline-none ">
          Ir a lacuarta.com
        </a>
      </div>
    </Wrapper>
  )
}

export default Final
